"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ManualColumnFreeze = void 0;
var _manualColumnFreeze = require("./manualColumnFreeze");
exports.PLUGIN_KEY = _manualColumnFreeze.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _manualColumnFreeze.PLUGIN_PRIORITY;
exports.ManualColumnFreeze = _manualColumnFreeze.ManualColumnFreeze;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualColumnFreeze/index.js
// module id = 1451
// module chunks = 0